import { api } from "@/services";
import { CarouselResponse } from "@/types";
import { useIsomorphicLayoutEffect } from "@/utilsV2";
import qs from "qs";
import { useState } from "react";

function useCarouselContents(): [
  Response: CarouselResponse,
  Error: string | null,
  Loading: boolean
] {
  const [Response, setResponse] = useState<CarouselResponse>(null);
  const [Error, setError] = useState<string>(null);
  const [Loading, setLoading] = useState(true);

  useIsomorphicLayoutEffect(() => {
    const Controller = new AbortController();

    const MakeRequest = async () => {
      try {
        const resp: { data: CarouselResponse } = await api.get(`Contents/GetBySlug`, {
          signal: Controller.signal,
          params: {
            slugs: ["carousel-linglong"]
          },
          paramsSerializer: (params) => {
            return qs.stringify(params, {
              arrayFormat: "repeat"
            });
          }
        });
        if (resp.data) {
          setResponse(resp.data);
        } else {
          setError("Nenhum conteúdo encontrado");
        }
      } catch (Err) {
        setError(Err.message);
      } finally {
        setLoading(false);
      }
    };

    MakeRequest();

    return () => Controller.abort();
  }, []);

  return [Response, Error, Loading];
}

export { useCarouselContents };
